module.exports = __webpack_public_path__ + "img/menu_id_card.13ea2098.svg";